<script setup>
import { ref, inject, toRefs } from 'vue'

import { Modal as AModal, InputPassword as AInputPassword } from 'ant-design-vue'

import { hashFnv32a } from '@/src/javascripts/script.js'
import mySwal from '@/src/javascripts/plugins/mySwal.js'

const props = defineProps({
  token: {
    type: String
  }
})
const { token } = toRefs(props)

const isUserSettingShow = inject('isUserSettingShow')

const userPassword = ref({
  old_password: '',
  new_password: '',
  confirm_password: ''
})

const closeUserSetting = () => {
  userPassword.value = {
    old_password: '',
    new_password: '',
    confirm_password: ''
  }

  isUserSettingShow.value = false
  isPasswordUnequal.value = false
}

const isPasswordUnequal = ref(false)

const submitForm = () => {
  if (userPassword.value.new_password !== userPassword.value.confirm_password) {
    isPasswordUnequal.value = true
  } else {
    isPasswordUnequal.value = false

    const { confirm_password, ...rest } = {
      ...userPassword.value,
      old_password: hashFnv32a(userPassword.value.old_password, true),
      new_password: hashFnv32a(userPassword.value.new_password, true)
    }

    $.ajax({
      url: '/reset_password',
      type: 'POST',
      dataType: 'json',
      headers: { 'X-CSRF-Token': token.value },
      authenticity_token: true,
      data: rest,
      success: async (response) => {
        if (response.state === 0) {
          mySwal.success({
            title: '密碼變更成功'
          })
          closeUserSetting()
        }
      },
      error: (error) => {
        console.log('error', error)
        if (error.responseJSON.state === -1) {
          closeUserSetting()
          mySwal.error({
            title: error.responseJSON.message
          })
        } else if (error.status === 0 && error.statusText === 'error') {
          mySwal.error({
            title: '網路錯誤，請稍後再試'
          })
        } else if (error.textStatus === 'timeout') {
          mySwal.error({
            title: '請求超時，請稍後再試'
          })
        } else if (error.textStatus === 'parsererror') {
          mySwal.error({
            title: '伺服器回應格式錯誤'
          })
        } else {
          mySwal.error({
            title: '系統錯誤'
          })
        }
      }
    })
  }
}
</script>
<template>
  <a-modal
    :visible="isUserSettingShow"
    title="變更密碼"
    :footer="null"
    :maskClosable="false"
    @cancel="closeUserSetting"
  >
    <form @submit.prevent="submitForm">
      <div class="px-3 pb-2">
        <label class="mb-2 block text-lg font-bold">
          <span>舊密碼</span>
          <a-input-password
            v-model:value="userPassword.old_password"
            class="w-full rounded-md border border-gray-300 p-2"
            required
          />
        </label>
        <label class="mb-2 flex flex-col text-lg font-bold">
          <span>新密碼</span>
          <a-input-password
            v-model:value="userPassword.new_password"
            class="w-full rounded-md border border-gray-300 p-2"
            :class="{
              'border-1 border-red-400': isPasswordUnequal
            }"
            required
          />
          <small v-if="isPasswordUnequal" class="font-normal text-red-400"> 請填寫相同密碼 </small>
        </label>
        <label class="mb-2 flex flex-col text-lg font-bold">
          <span>確認密碼</span>
          <a-input-password
            v-model:value="userPassword.confirm_password"
            class="w-full rounded-md border border-gray-300 p-2"
            :class="{
              'border-1 border-red-400': isPasswordUnequal
            }"
            required
          />
          <small v-if="isPasswordUnequal" class="font-normal text-red-400"> 請填寫相同密碼 </small>
        </label>
      </div>
      <div class="-mx-6 flex items-center justify-end gap-4 border-t-2 px-6 py-2">
        <button type="button" class="btn btn-ghost text-base" @click="closeUserSetting">
          取消
        </button>
        <button
          type="submit"
          class="block rounded-md border-scp-royal-blue bg-scp-royal-blue p-3 text-base font-semibold text-white hover:bg-blue-800"
        >
          送出
        </button>
      </div>
    </form>
  </a-modal>
</template>
<style lang="scss" scoped></style>
